export const CacheConstants = {
  TOKEN_KEY : 'dco-token',
  USERNAME_KEY : 'dco-username',
  USER_ID_KEY : 'USER_ID_KEY',
  COMMERCE_KEY : 'USER_COMMERCE_KEY',
  TOKEN_DATA : 'TOKEN_DATA',
  USER_KEY : 'dco-user',
  VALIDATIONDATA_KEY : 'dco-validation',
  USERDATA_KEY : 'dco-validation',
  LANGUAGE_CACHE_VERSION : 'language_cache_version',
  PAGES_CACHE_VERSION : 'pages_cache_version'
};
